export enum TestType {
  HTTP = 'http',
  AUTH = 'auth',
  TRACEROUTE = 'traceroute'
}
